<template>
    <div class="support-page">
  
      <DefaultHeader title="Поддержка" :back="false" />
  
      <div class="support-content">
  
        <div class="support-hero">
  
          <img
            src="../assets/support-hero.png"
            alt="Support"
            class="hero-image"
          />
  
          <div class="hero-overlay"></div>
  
          <div class="support-info">
  
            <div class="badge">
              HR3 SUPPORT
            </div>
  
            <h1 class="title">
              Мы всегда на связи
            </h1>
  
            <p class="subtitle">
              Если у вас возникли вопросы, проблемы с аккаунтом
              или предложения по улучшению платформы —
              наша команда поддержки поможет вам.
            </p>
  
            <div class="support-buttons">
  
              <button class="support-btn primary" @click="openSupport">
                💬 Написать в поддержку
              </button>
  
              <button class="support-btn secondary" @click="sendEmail">
                📩 tech@hr3.space
              </button>
  
            </div>
  
          </div>
        </div>
  
        <div class="support-grid">
  
          <div class="support-card">
            <div class="card-icon">⚡</div>
            <div class="card-title">Быстрый ответ</div>
            <div class="card-text">
              Обычно мы отвечаем в течение нескольких часов.
            </div>
          </div>
  
          <div class="support-card">
            <div class="card-icon">🔒</div>
            <div class="card-title">Безопасность</div>
            <div class="card-text">
              Все обращения обрабатываются конфиденциально.
            </div>
          </div>
  
          <div class="support-card">
            <div class="card-icon">🌍</div>
            <div class="card-title">Доступность</div>
            <div class="card-text">
              Поддержка доступна для пользователей из любых стран.
            </div>
          </div>
  
        </div>
  
      </div>
  
      <MiniFooter />
  
      <SupportDrawer
        :visible="drawerVisible"
        @close="drawerVisible = false"
      />
  
    </div>
  </template>
  
  <script setup>
  
  import { ref } from 'vue'
  
  import DefaultHeader from '../components/DefaultHeader.vue'
  import MiniFooter from '../components/MiniFooter.vue'
  import SupportDrawer from '../components/profile/ContactSupportDrawer.vue';

  const drawerVisible = ref(false)
  
  function openSupport() {
    drawerVisible.value = true
  }
  
  function sendEmail() {
    window.location.href = "mailto:tech@hr3.space"
  }
  
  </script>
  
  <style scoped>
  
  .support-page {

height: 100vh;

background: var(--bg-main);

overflow: hidden;

display: flex;

flex-direction: column;

}
  
.support-content {
flex: 1;
width: 100%;
max-width: 900px;
margin: 0 auto;
padding: 40px 24px 140px;
overflow-y: auto;
overflow-x: hidden;
scrollbar-width: none;
}

.support-content::-webkit-scrollbar {
display: none;
}
  
.support-hero {
width: 900px;
height: 600px;
position: relative;
border-radius: 32px;
overflow: hidden;
background: #3B82F6;
}
  
.hero-image {
width: 900px;
height: 600px;
object-fit: contain;
object-position: center;
}
  
  
.support-info {
  position: absolute;
  left: 34px;
  bottom: 64px;
  max-width: 620px;
  z-index: 2;
}
  
.badge {
  display: inline-flex;
  padding: 8px 14px;
  border-radius: 999px;
  background: rgba(255,255,255,.12);
  backdrop-filter: blur(12px);
  color: white;
  font-size: 12px;
  letter-spacing: .08em;
  margin-bottom: 18px;
  font-family: "Eastman-Medium";
}

.title {
  font-size: 44px;
  line-height: 1.05;
  color: white;
  margin: 0;
  font-family: "Eastman-Bold";
}

.subtitle {
  margin-top: 18px;
  color: rgba(255,255,255,.84);
  font-size: 12px;
  line-height: 1.6;
  max-width: 560px;
  font-family: "Eastman-Regular";
}

.support-buttons {
  display: flex;
  gap: 16px;
  margin-top: 32px;
  flex-wrap: wrap;
}

.support-btn {
  border: none;
  border-radius: 999px;
  padding: 14px 26px;
  cursor: pointer;
  font-size: 15px;
  transition: .2s ease;
  font-family: "Eastman-Medium";
}

.support-btn.primary {
  background: white;
  color: black;
}

.support-btn.primary:hover {
  transform: translateY(-1px);
}

.support-btn.secondary {
  background: rgba(255,255,255,.12);
  color: white;
  border: 1px solid rgba(255,255,255,.2);
  backdrop-filter: blur(12px);
}

.support-grid {
  margin-top: 28px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.support-card {
  padding: 28px;
  border-radius: 24px;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
}

.card-icon {
  font-size: 28px;
  margin-bottom: 18px;
}

.card-title {
  font-size: 18px;
  font-family: "Eastman-Bold";
  color: var(--text-primary);
}

.card-text {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-secondary);
  font-family: "Eastman-Regular";
}

@media (max-width: 768px) {

.support-content {
  padding: 12px 12px 100px;
}

.support-hero {
  min-height: auto;
  aspect-ratio: 3 / 4;
  border-radius: 24px;
}

.hero-image {
  object-fit: cover;
  object-position: center;
}

.hero-overlay {
  background:
    linear-gradient(
      to top,
      rgba(0,0,0,.82),
      rgba(0,0,0,.22)
    );
}

.support-info {
  left: 20px;
  right: 20px;
  bottom: 20px;
  max-width: none;
}

.badge {
  font-size: 10px;
  padding: 7px 12px;
  margin-bottom: 14px;
}

.title {
  font-size: 32px;
  line-height: 1.05;
}

.subtitle {
  margin-top: 14px;
  font-size: 14px;
  line-height: 1.5;
  max-width: 100%;
}

.support-buttons {
  margin-top: 24px;
  flex-direction: column;
  gap: 12px;
}

.support-btn {
  width: 100%;
  justify-content: center;
  font-size: 14px;
  padding: 14px 18px;
}

.support-grid {
  margin-top: 18px;
  grid-template-columns: 1fr;
  gap: 14px;
}

.support-card {
  padding: 22px;
  border-radius: 20px;
}

.card-icon {
  font-size: 24px;
  margin-bottom: 14px;
}

.card-title {
  font-size: 16px;
}

.card-text {
  font-size: 13px;
  line-height: 1.45;
}
}

:deep(.default-header) {
position: sticky;
top: 0;
z-index: 1000;
backdrop-filter: blur(20px);
}

:deep(.mini-footer) {
position: sticky;
bottom: 0;
z-index: 1000;
backdrop-filter: blur(20px);
}
  
  </style>